// Every Australian rules football incident type LSports can send (see the
// provider's "Aussie Rules – Incident ID / Incident Name / Kind" list),
// classified for the AussieRulesArena:
//   key      – i18n key of the incident name shown on the oval
//   ignore   – not an oval incident: player-level stats, totals, status/meta
//              records
// `track: false` = an event type we react to only when the feed names it as
// CurrentIncident, not when its statistic goes up.
// Goals (6 points) and behinds (1 point) are read from the scoreboard: a
// score going up by 6 or more is a goal, by less a behind.
export const AFL_SPORT_ID = '389537';
export const AFL_BEHIND_TYPE = 2032;
// Stat totals the arena shows (goals.behinds on the final badge).
export const AFL_GOALS_STAT = 2033;

export const AFL_INCIDENTS = {
    9: {key: 'afl.goal', track: false},
    11: {key: 'afl.inpossession', track: false},
    27: {ignore: true},                         // Score (scoreboard)
    87: {ignore: true},                         // Disposals = kicks + hand balls
    91: {key: 'afl.kick'},
    1030: {ignore: true},                       // Player Goals
    2032: {key: 'afl.behind', track: false},    // Behind: from the scoreboard
    2033: {ignore: true},                       // Goals: from the scoreboard
    2228: {key: 'afl.tackle'},
    2277: {ignore: true},                       // Period (scoreboard)
    2278: {ignore: true},                       // FixtureStatus (scoreboard)
    2280: {ignore: true},                       // HasPlayed
    2299: {key: 'afl.handball'},
    2300: {key: 'afl.freekick'},
    2301: {ignore: true},                       // Free Against: the other team's Free For
    2302: {key: 'afl.clearance'},
    2303: {key: 'afl.mark'},
    2304: {key: 'afl.hitout'},
    2305: {ignore: true},
    2306: {ignore: true},
    2307: {ignore: true},
    2308: {ignore: true},
    2309: {ignore: true},
    2462: {ignore: true}                        // StatusDescription
};

// Which incident wins when several arrive in the same update (higher = shown):
// a kick that ends in a mark is announced as the mark.
export const AFL_PRIORITY = {9: 100, 2032: 90, 2300: 70, 2303: 60, 2228: 50, 2302: 45, 2304: 40, 91: 10, 2299: 8, 11: 1};

// { type, ignored, known } for a raw provider type.
export function resolveAflType(rawType) {
    const t = parseInt(rawType) || 0;
    const def = AFL_INCIDENTS[t];
    if (!def) return {type: t, ignored: false, known: false, breakTime: false};
    return {type: t, ignored: !!def.ignore, known: true, breakTime: false};
}

// Team statistics whose increase is read as "this just happened".
export const AFL_STATS_TO_TRACK = Object.keys(AFL_INCIDENTS)
    .map(Number)
    .filter(t => AFL_INCIDENTS[t].key && AFL_INCIDENTS[t].track !== false);

export function aflIncidentKey(type) {
    const def = AFL_INCIDENTS[type];
    return def && def.key ? def.key : null;
}
